export const defs = (
  <defs>
    <linearGradient id='0' x1='0' x2='0' y1='1' y2='0'>
      <stop offset='0%' stopColor='#17EAD9' />
      <stop offset='100%' stopColor='#6078EA' />
    </linearGradient>
    <linearGradient id='1' x1='0' x2='0' y1='1' y2='0'>
      <stop offset='0%' stopColor='#FCE38A' />
      <stop offset='100%' stopColor='#F38181' />
    </linearGradient>
    <linearGradient id='2' x1='0' x2='0' y1='1' y2='0'>
      <stop offset='0%' stopColor='#42E695' />
      <stop offset='100%' stopColor='#3BB2B8' />
    </linearGradient>
    <linearGradient id='3' x1='0' x2='0' y1='1' y2='0'>
      <stop offset='0%' stopColor='#F4Ea0A' />
      <stop offset='100%' stopColor='#df4081' />
    </linearGradient>
    <linearGradient id='4' x1='0' x2='0' y1='1' y2='0'>
      <stop offset='0%' stopColor='#d1d1d1' />
      <stop offset='100%' stopColor='#262626' />
    </linearGradient>
    <linearGradient id='6' x1='0' x2='0' y1='1' y2='0'>
      <stop offset='0%' stopColor='#21CBF3' />
      <stop offset='100%' stopColor='#2196F3' />
    </linearGradient>
  </defs>
);

export const axes = [
  {
    primary: true,
    type: "ordinal",
    position: "bottom",
    show: false,
  },
  {
    type: "linear",
    position: "left",
    stacked: true,
    show: false,
  },
];
